export interface Language {
  code: string;
  label: string;
}

export const availableLanguages: Language[] = [
  {
    code: 'de',
    label: 'DE / Deutsch',
  },
  {
    code: 'nl',
    label: 'NL / Nederlands',
  },
  {
    code: 'en',
    label: 'EN / English',
  },
];
